import {useEffect, useState} from "react";
import {Dialog, Grid, IconButton, Typography} from "@mui/material";
import {Close} from "@mui/icons-material";
import Dialogo_Recibo from "../Dialogos/Dialogo_Recibo";
import {consultarPagoReferencia} from "../Funciones/consultarPagoReferencia";

export const useReciboPago = ({logo}) => {
    const [datosRecibo, setDatosRecibo] = useState({})
    const [open, setOpen] = useState(false)
    const [referencia, setReferencia] = useState('')

    const abrir = () => {
        setOpen(true)
    }

    const abrirRecibo = async (datos) => {

        let data = await consultarPagoReferencia(datos.referencia)
        setDatosRecibo(data.data)
        setReferencia(datos.referencia)
        setOpen(true)

    }

    const cerrar = () => {
        setOpen(false)
    }


    const Dialogo = () => {
        return (
            <Dialog open={open} fullWidth maxWidth={'xs'}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="flex-start"
                    sx={{p: 2}}
                    size={12}
                >

                    <Grid item container size={8} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600, color: '#00000080', fontSize: 16}}></Typography>
                    </Grid>

                    <Grid item container size={4} sx={{justifyContent: 'flex-end', marginTop: 0}}>
                        <IconButton
                            onClick={() => cerrar()}
                        >
                            <Close/>
                        </IconButton>
                    </Grid>


                    <Dialogo_Recibo logo={logo} datos={datosRecibo} referencia={referencia}/>

                </Grid>

            </Dialog>
        )
    }

    function getQueryVariable(variable) {
        let query = window.location.search.substring(1);
        let vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=');
            if (pair[0] === variable) {
                return pair[1];
            }
        }
        return false;
    }

    const getDatos = (ref) => {

        fetch('https://secure.epayco.co/validation/v1/reference/' + ref)
            .then(async (response) => {
                const data = await response.json();
                setDatosRecibo(data.data)
                abrir()


            })
            .catch((error) => {
                console.error('There was an error!', error);
            });

    };

    useEffect(() => {


        let ref = getQueryVariable('ref_payco');
        // console.log(ref)

        if (ref !== false && ref !== 'undefined') {
            setReferencia(ref)
            getDatos(ref)
        }

    }, [])

    return {
        Dialogo,
        abrirRecibo
    }

}